import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {userDisableMfaError, userDisableMfaSuccess, userEnableMfaError, userEnableMfaSuccess} from "./actions";
import {DISABLE_MFA, ENABLE_MFA, INIT_MFA} from "./actionTypes";
import {disableMfa, enableMfa} from "../../../helpers/auth";
import {userUpdated} from "../user/actions";

function* initMfaData({payload: {req, history}}) {
    try {
        yield put(initMfa());
    } catch (error) {
        yield put(userDisableMfaError("Init mfa data error"));
    }
}

function* enableMfaUser({payload: {req, history}}) {
    try {
        const response = yield call(enableMfa, req);
        yield put(userEnableMfaSuccess());
        yield put(userUpdated(response));
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
        yield put(userEnableMfaError(error));
    }
}

function* disableMfaUser({payload: {req, history, callback}}) {
    try {
        const response = yield call(disableMfa, req);
        yield put(userDisableMfaSuccess());
        yield put(userUpdated(response));
        if (callback) callback(); 
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
        yield put(userDisableMfaError(error));
    }
}

export function* initMfa() {
    yield takeEvery(INIT_MFA, initMfaData());
}

export function* watchUserMfaEnable() {
    yield takeEvery(ENABLE_MFA, enableMfaUser);
}

export function* watchUserMfaDisable() {
    yield takeEvery(DISABLE_MFA, disableMfaUser);
}

function* authSaga() {
    yield all([
        fork(watchUserMfaEnable),
        fork(watchUserMfaDisable),
    ]);
}

export default authSaga;